// removed by extract-text-webpack-plugin
module.exports = {"social-media-button":"social-media-button","btn-default":"btn-default"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/SocialMediaButton/SocialMediaButton.scss
// module id = W5Ro
// module chunks = 0